import { augmentLocations } from "./getters";

export default {
  initialize({ state, commit, getters, dispatch }) {
    if (state.current) {
      dispatch('reset');
    }

    commit('set', { locations: augmentLocations(getters.rootLocations) });

    return { ok: true };
  },

  next({ getters, dispatch }, nextPanelAction) {
    if (getters.selectionsComplete) {
      nextPanelAction();
    } else {
      dispatch('update')
    }

    return { ok: true }
  },

  reset({ commit }) {
    commit('reset');

    return { ok: true };
  },

  set({ state, commit }, location) {
    if (location && location !== 'unknown') {
      const locationObj = state.locations.find((loc) => loc.value === location);

      commit(
        'set',
        {
          current: locationObj,
          selectionMade: true,
        },
      );
    }

    return { ok: true };
  },

  update({ state, commit, getters }) {
    if (state.current) {
      commit('set', { locations: getters.childLocations, selectionMade: false });
    }

    return { ok: true };
  }
}
